var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.blockClassName},[_c('div',{class:[_vm.childrenClassName('title'), { separator: _vm.separator }, { primaryTitle: _vm.primaryTitle }]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{class:_vm.childrenClassName('content')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }